/* ============================================================
   ASTRON — storefront interactions (catalog → marketplaces)
   ============================================================ */
(function () {
  "use strict";

  // ---- Product images (real Astron Shopify CDN) ----
  const IMG = {
    rcBeige:  "https://www.astron.com.ph/cdn/shop/products/1984e187170ffe523d36a476326d3097_800x800.jpg?v=1754985194",
    rcMint:   "https://www.astron.com.ph/cdn/shop/products/538c1d05614b74df0d2f836140cb02e8_800x800.jpg?v=1754985202",
    rcGreen:  "https://www.astron.com.ph/cdn/shop/products/3d10a6b2d2db8734f42b54253a1b474f_800x800.jpg?v=1754985162",
    riceKim:  "https://www.astron.com.ph/cdn/shop/files/kim1_1000x562.png?v=1638428482",
    oven:     "https://cdn.shopify.com/s/files/1/0546/0908/4595/files/IG5_719x719_128822b0-5f75-4b51-9992-1aaeef0cf6c2.webp?v=1734627247",
    kettle:   "https://cdn.shopify.com/s/files/1/0546/0908/4595/files/aqua1_719x719_d7940bb6-3bdc-4704-bfa2-91eb0bbc814c.webp?v=1734627462",
    stove:    "https://cdn.shopify.com/s/files/1/0546/0908/4595/files/gs8080_719x719_1e48ddcd-663d-424b-a8c1-011b68696fa8.webp?v=1734627488",
    airfryer: "https://cdn.shopify.com/s/files/1/0546/0908/4595/files/airfryer_719x719_3a0d0fa7-449c-46e6-bb6b-b3dc59a910e4.webp?v=1734627506",
    stoveLife:"https://www.astron.com.ph/cdn/shop/files/DSC8125_900x1350.jpg?v=1740540824",
    washLife: "https://www.astron.com.ph/cdn/shop/files/Adobe_Express_-_file_1_1080x1350.jpg?v=1740551704",
    cookLife: "https://www.astron.com.ph/cdn/shop/files/Resize_image_project_1350x1350.png?v=1740550846",
    tvLife:   "https://www.astron.com.ph/cdn/shop/files/DSC9290_1350x901.jpg?v=1740540514",
    moodHome: "https://www.astron.com.ph/cdn/shop/files/Screenshot_2025-02-28_144107_1350x754.png?v=1740739200",
    moodHeat: "https://www.astron.com.ph/cdn/shop/files/Screenshot_2025-02-28_143527_8bc2a95d-6f5e-4b31-8fd7-3ed36fe7d04e_1350x753.png?v=1740739200",
    moodRain: "https://www.astron.com.ph/cdn/shop/files/Screenshot_2025-02-28_144354_1350x753.png?v=1740739200"
  };
  window.ASTRON_IMG = IMG;

  // ---- Marketplace storefronts ----
  const MARKET = {
    shopee: "https://shopee.ph/universal-link/astronappliancesph",
    lazada: "https://s.lazada.com.ph/a.m1V",
    tiktok: "https://www.tiktok.com/@astronappliancesph"
  };
  const MK_ICON_UNUSED = null;
  // Build the three branded buy buttons (text only, no logos).
  function buyButtons(label, compact) {
    const order = ["shopee", "lazada", "tiktok"];
    const names = { shopee: "Shopee", lazada: "Lazada", tiktok: "TikTok" };
    return `<div class="buy-btns${compact ? ' compact' : ''}">
      ${order.map(k => `<a class="buy-btn buy-${k}" href="${MARKET[k]}" target="_blank" rel="noopener" aria-label="Buy ${label || 'this'} on ${names[k]}"><span class="bb-name">${names[k]}</span></a>`).join("")}
    </div>`;
  }

  // ---- Helpers ----
  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  // ---- Sticky header (fixed via JS — works inside any Shopify section wrapper) ----
  const header = $("header.site");
  const topbar = $(".topbar");
  if (header && topbar) {
    const placeholder = document.createElement("div");
    placeholder.style.cssText = "display:none;height:0";
    header.after(placeholder);

    const STICKY_THRESHOLD = 24;
    const update = () => {
      const past = window.scrollY >= STICKY_THRESHOLD;
      header.classList.toggle("is-sticky", past);
      header.classList.toggle("scrolled", past);
      if (past) {
        placeholder.style.height = header.offsetHeight + "px";
        placeholder.style.display = "block";
      } else {
        placeholder.style.display = "none";
      }
    };

    window.addEventListener("scroll", update, { passive: true });
    update();
  }

  // ---- Back to top button ----
  const backToTop = $("#backToTop");
  if (backToTop) {
    const BACK_TO_TOP_THRESHOLD = 600;
    const updateBackToTop = () => backToTop.classList.toggle("show", window.scrollY > BACK_TO_TOP_THRESHOLD);
    window.addEventListener("scroll", updateBackToTop, { passive: true });
    updateBackToTop();
    backToTop.addEventListener("click", () => window.scrollTo({ top: 0, behavior: "smooth" }));
  }

  // ---- Mega dropdown: keep it fully inside the viewport, whichever side it overflows ----
  const MEGA_EDGE_MARGIN = 12;
  $$(".nav-item").forEach((item) => {
    const mega = item.querySelector(".mega");
    if (!mega) return;
    const checkOverflow = () => {
      mega.classList.remove("mega-right");
      mega.style.left = "0px";
      mega.style.right = "auto";
      const rect = mega.getBoundingClientRect();
      const overflowRight = rect.right - (window.innerWidth - MEGA_EDGE_MARGIN);
      const overflowLeft = MEGA_EDGE_MARGIN - rect.left;
      if (overflowRight > 0) {
        mega.style.left = `${-overflowRight}px`;
      } else if (overflowLeft > 0) {
        mega.style.left = `${overflowLeft}px`;
      }
    };
    item.addEventListener("mouseenter", checkOverflow);
    item.addEventListener("focusin", checkOverflow);
  });

  // ---- Scroll-reveal: add .in-view to animated sections ----
  (function () {
    const targets = $$(".market, .trust");
    if (!targets.length) return;
    if (!("IntersectionObserver" in window)) {
      targets.forEach(el => el.classList.add("in-view"));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add("in-view"); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    targets.forEach(el => io.observe(el));
  })();

  // ---- Hero featured carousel ----
  const heroData = [
    { cat: "Rice Cooker", name: "Astron JRC-101 Jar Type Rice Cooker — Nude Beige", badge: "★ Bestseller", img: IMG.rcBeige, rating: "4.9", count: "1,204" },
    { cat: "Air Fryer",   name: "Astron AF-260D 3.8L Digital Air Fryer — 1450W", badge: "New arrival", img: IMG.airfryer, rating: "4.8", count: "863" },
    { cat: "Multi-Cooker", name: "Astron Multi-Cooker & Pot Steamer — Pastel Green", badge: "★ Bestseller", img: IMG.rcMint, rating: "4.9", count: "2,011" }
  ];
  let heroIdx = 0;
  const heroCard = $("#heroCard");
  function renderHero(i) {
    const d = heroData[i];
    heroCard.querySelector(".save-tag").textContent = d.badge;
    heroCard.querySelector(".ph img").src = d.img;
    heroCard.querySelector(".ph img").alt = d.name;
    heroCard.querySelector(".hc-cat").textContent = d.cat;
    heroCard.querySelector("h3").textContent = d.name;
    heroCard.querySelector(".stars .rt").textContent = d.rating + " (" + d.count + " sold)";
    $$("#heroThumbs button").forEach((b, bi) => b.classList.toggle("active", bi === i));
  }
  if (heroCard) {
    $$("#heroThumbs button").forEach((b, i) => b.addEventListener("click", () => { heroIdx = i; renderHero(i); }));
    setInterval(() => { heroIdx = (heroIdx + 1) % heroData.length; renderHero(heroIdx); }, 5000);
    renderHero(0);
  }

  // ---- Products ----
  const products = [
    { id: "jrc101", cat: "Rice Cooker", name: "Astron JRC-101 1L Jar Type Rice Cooker — Nude Beige", img: IMG.rcBeige, rating: "4.9", count: 1204, tag: "Bestseller" },
    { id: "af260",  cat: "Air Fryer",   name: "Astron AF-260D 3.8L Digital Air Fryer — Black", img: IMG.airfryer, rating: "4.8", count: 863, tag: "Sale" },
    { id: "multi",  cat: "Multi-Cooker", name: "Astron Multi-Cooker & Pot Steamer — Pastel Green", img: IMG.rcMint, rating: "4.9", count: 2011, tag: "Sale" },
    { id: "eo65",   cat: "Oven",        name: "Astron EO-65 Electric Oven — 65L Convection", img: IMG.oven, rating: "4.7", count: 412, tag: null },
    { id: "aqua",   cat: "Kettle",      name: "Astron Aqua 1.8L Electric Kettle — Stainless", img: IMG.kettle, rating: "4.8", count: 728, tag: "New" },
    { id: "gs8080", cat: "Gas Stove",   name: "Astron GS-8080 Heavy-Duty Double Burner Gas Stove", img: IMG.stove, rating: "4.9", count: 590, tag: null },
    { id: "jrc061", cat: "Rice Cooker", name: "Astron JRC-061 0.6L Jar Type Rice Cooker — Mint Green", img: IMG.rcGreen, rating: "4.9", count: 1556, tag: "Bestseller" },
    { id: "kim",    cat: "Rice Cooker", name: "Astron 1.0L Jar Type Rice Cooker — Classic White", img: IMG.riceKim, rating: "4.7", count: 980, tag: null }
  ];

  function starRow(rating, count) {
    return `<span class="s">★★★★★</span> ${rating}${count ? ' · ' + count.toLocaleString('en-PH') + ' sold' : ''}`;
  }
  function productCard(p) {
    const tagHtml = p.tag ? `<span class="tag ${/new/i.test(p.tag) ? 'new' : ''}">${p.tag}</span>` : "";
    return `<article class="card">
      <div class="media">
        ${tagHtml}
        <button class="wish" aria-label="Add to wishlist">${ICON.heart}</button>
        <img src="${p.img}" alt="${p.name}" loading="lazy">
      </div>
      <div class="body">
        <span class="cat">${p.cat}</span>
        <h3>${p.name}</h3>
        <div class="stars">${starRow(p.rating, p.count)}</div>
      </div>
    </article>`;
  }
  const grid = $("#prodGrid");
  if (grid) grid.innerHTML = products.map(productCard).join("");

  // ---- Overlay + mobile nav (no cart on this catalog site) ----
  const overlay = $("#overlay");
  const mobileNav = $("#mobileNav");
  function closeAll() {
    if (mobileNav) mobileNav.classList.remove("open");
    if (overlay) overlay.classList.remove("open");
    document.body.style.overflow = "";
  }
  const hb = $("#hamburger");
  if (hb) hb.addEventListener("click", () => {
    const isOpen = mobileNav.classList.contains("open");
    if (isOpen) {
      closeAll();
    } else {
      mobileNav.classList.add("open"); overlay.classList.add("open"); document.body.style.overflow = "hidden";
    }
  });
  const cm = $("#closeMobile");
  if (cm) cm.addEventListener("click", closeAll);
  if (overlay) overlay.addEventListener("click", closeAll);
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeAll(); });
  $$(".mn-acc > button").forEach(b => b.addEventListener("click", () => b.parentElement.classList.toggle("open")));

  // ---- Header search toggle ----
  const searchToggle = $("#searchToggle");
  const searchBox = $("#searchBox");
  if (searchToggle && searchBox) {
    searchToggle.addEventListener("click", (e) => {
      e.stopPropagation();
      const isOpen = searchBox.classList.toggle("open");
      searchToggle.setAttribute("aria-expanded", String(isOpen));
      if (isOpen) searchBox.querySelector("input").focus();
    });
    document.addEventListener("click", (e) => {
      if (!searchBox.contains(e.target) && !searchToggle.contains(e.target)) {
        searchBox.classList.remove("open");
        searchToggle.setAttribute("aria-expanded", "false");
      }
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        searchBox.classList.remove("open");
        searchToggle.setAttribute("aria-expanded", "false");
      }
    });
  }

  // ---- Toast ----
  let toastTimer;
  function toast(msg) {
    const t = $("#toast");
    if (!t) return;
    t.querySelector(".msg").textContent = msg;
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove("show"), 2600);
  }

  // ---- Mood tabs ----
  $$(".mood-tab").forEach(tab => {
    tab.addEventListener("click", () => {
      const m = tab.dataset.mood;
      $$(".mood-tab").forEach(t => t.classList.toggle("active", t === tab));
      $$(".ms-panel").forEach(p => p.classList.toggle("active", p.dataset.mood === m));
    });
  });

  // ---- Newsletter ----
  const nf = $("#newsForm");
  if (nf) nf.addEventListener("submit", (e) => { e.preventDefault(); nf.reset(); toast("Salamat! You’re on the list 💙"); });

  // ============================================================
  // ANNOUNCEMENTS CAROUSEL
  // Add/remove slides below. Leave the array EMPTY ( [] ) and the
  // whole section hides itself automatically.
  //   img      — banner image URL (wide/landscape works best)
  //   href     — where the slide links to (use "#" or "" for none)
  //   alt      — accessibility text
  //   headline — optional overlay title
  //   sub      — optional overlay subtitle
  //   cta      — optional button label
  // ============================================================
  const ANNOUNCEMENTS = [
    { img: IMG.airfryer, href: "https://shopee.ph/universal-link/astronappliancesph", alt: "New Astron Air Fryer", headline: "Bagong Labas: AF-260D Air Fryer", sub: "3.8L digital, 1450W — now on Shopee, Lazada & TikTok", cta: "Shop now" },
    { img: IMG.moodHeat, href: "#", alt: "Summer aircon sale", headline: "Beat the Heat Sale", sub: "Inverter-class aircon at sulit prices this summer", cta: "See deals" },
    { img: IMG.rcMint, href: "#", alt: "New rice cooker colors", headline: "New Pastel Colorways", sub: "Aesthetic rice cookers para sa modern kitchen", cta: "Explore" }
  ];

  (function initAnnounce() {
    const section = $("#announce");
    if (!section) return;
    const slides = ANNOUNCEMENTS.filter(a => a && a.img);
    if (!slides.length) { section.hidden = true; return; }   // nothing to post → stay hidden
    section.hidden = false;

    const track = $("#announceTrack");
    const dotsWrap = $("#announceDots");
    const prev = $("#annPrev"), next = $("#annNext");
    const single = slides.length === 1;

    track.innerHTML = slides.map((a, i) => {
      const linkAttr = (a.href && a.href !== "") ? ` href="${a.href}"${/^https?:/.test(a.href) ? ' target="_blank" rel="noopener"' : ""}` : "";
      const ctaTag = linkAttr ? "a" : "span";
      const label = a.cta || "Learn more";
      const overlay = (a.headline || a.sub || linkAttr) ? `
        <div class="ann-overlay ann-overlay-text">
          ${a.headline ? `<h3>${a.headline}</h3>` : ""}
          ${a.sub ? `<p>${a.sub}</p>` : ""}
          ${linkAttr ? `<${ctaTag} class="ann-cta"${linkAttr}>${label} <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg></${ctaTag}>` : ""}
        </div>` : "";
      return `<div class="ann-cell"><div class="ann-slide"><image-slot id="announce-${i}" src="${a.img}" fit="cover" placeholder="${a.alt || 'Announcement banner'}"></image-slot>${overlay}</div></div>`;
    }).join("");

    // dots + arrows only when more than one
    if (single) {
      prev.style.display = next.style.display = "none";
      dotsWrap.style.display = "none";
    } else {
      dotsWrap.innerHTML = slides.map((_, i) => `<button class="ann-dot${i === 0 ? " active" : ""}" data-i="${i}" aria-label="Slide ${i + 1}"></button>`).join("");
    }

    let idx = 0, timer = null;
    function go(i) {
      idx = (i + slides.length) % slides.length;
      track.style.transform = `translateX(-${idx * 100}%)`;
      $$("#announceDots .ann-dot").forEach((d, di) => d.classList.toggle("active", di === idx));
    }
    function start() { if (!single) { stop(); timer = setInterval(() => go(idx + 1), 5500); } }
    function stop() { if (timer) clearInterval(timer); }

    prev.addEventListener("click", () => { go(idx - 1); start(); });
    next.addEventListener("click", () => { go(idx + 1); start(); });
    dotsWrap.addEventListener("click", (e) => { const d = e.target.closest(".ann-dot"); if (d) { go(+d.dataset.i); start(); } });
    const carousel = section.querySelector(".announce-carousel");
    carousel.addEventListener("mouseenter", stop);
    carousel.addEventListener("mouseleave", start);
    go(0); start();
  })();

  // ============================================================
  // AIRCON FINDER — recommend HP capacity by room size
  // To assign specific models later, fill each tier's `model`:
  //   model: { name: "Astron ...", img: "url", href: "url" }
  // Leave model: null to show the generic "Shop X HP" button.
  // ============================================================
  const AIRCON_TIERS_DEFAULT = [
    { max: 7,        hp: "0.5 HP",  btu: "~5,000 BTU",  pct: 14,  blurb: "Perfect for very small rooms, cubicles, and study nooks.", model: null },
    { max: 11,       hp: "0.75 HP", btu: "~6,000 BTU",  pct: 28,  blurb: "Ideal for small bedrooms and compact spaces.", model: null },
    { max: 15,       hp: "1.0 HP",  btu: "~9,000 BTU",  pct: 43,  blurb: "Great for standard bedrooms.", model: null },
    { max: 21,       hp: "1.5 HP",  btu: "~12,000 BTU", pct: 57,  blurb: "Best for master bedrooms and small living rooms.", model: null },
    { max: 28,       hp: "2.0 HP",  btu: "~18,000 BTU", pct: 71,  blurb: "Suited for living rooms and medium spaces.", model: null },
    { max: 36,       hp: "2.5 HP",  btu: "~21,000 BTU", pct: 86,  blurb: "For large living areas and small offices.", model: null },
    { max: Infinity, hp: "3.0 HP",  btu: "~24,000 BTU", pct: 100, blurb: "For big halls and open spaces — you may also consider 2 units.", model: null }
  ];
  // Editable per-tier content comes from the section's "Capacity tier" blocks in the
  // Shopify customizer (see aircon-finder.liquid), which sets window.AIRCON_TIERS_OVERRIDE.
  // Falls back to the defaults above if no blocks are configured.
  const AIRCON_TIERS = (window.AIRCON_TIERS_OVERRIDE && window.AIRCON_TIERS_OVERRIDE.length)
    ? window.AIRCON_TIERS_OVERRIDE
    : AIRCON_TIERS_DEFAULT;
  const AIRCON_SHOP_URL = "https://shopee.ph/universal-link/astronappliancesph";

  (function initAirconFinder() {
    const areaEl = $("#afArea");
    if (!areaEl) return;
    const hpEl = $("#afHp"), btuEl = $("#afBtu"),
          blurbEl = $("#afBlurb"), modelEl = $("#afModel"), shopEl = $("#afShop"),
          barEl = $("#afBar");

    function pickTier(area) {
      return AIRCON_TIERS.find(t => area <= t.max) || AIRCON_TIERS[AIRCON_TIERS.length - 1];
    }
    function popHp() {
      hpEl.classList.remove("pop");
      hpEl.getBoundingClientRect();
      hpEl.classList.add("pop");
    }
    function render() {
      const area = parseFloat(areaEl.value) || 0;
      const roomEl = $("#afRoom");
      if (area <= 0) {
        hpEl.textContent = "—";
        btuEl.textContent = "";
        if (roomEl) roomEl.textContent = "";
        if (barEl) barEl.style.width = "0%";
        blurbEl.textContent = "Enter your room size to see a recommendation.";
        modelEl.innerHTML = "";
        shopEl.style.display = "none";
        return;
      }

      const t = pickTier(area);
      hpEl.textContent = t.hp;
      btuEl.textContent = t.btu;
      if (roomEl) roomEl.textContent = "For a room around " + area + " sqm";
      if (barEl) barEl.style.width = t.pct + "%";
      popHp();
      blurbEl.textContent = t.blurb;

      if (t.model) {
        modelEl.innerHTML = `<a class="afr-model-card" href="${t.model.href || '#'}"${/^https?:/.test(t.model.href || '') ? ' target="_blank" rel="noopener"' : ''}>
          <img src="${t.model.img}" alt="${t.model.name}">
          <div><span>Recommended model</span><b>${t.model.name}</b></div>
        </a>`;
        shopEl.style.display = "none";
      } else {
        modelEl.innerHTML = `<div class="afr-model-soon"><span class="afr-soon-ico">✦</span> Matched Astron ${t.hp} models coming soon</div>`;
        shopEl.style.display = "";
        shopEl.textContent = `Shop ${t.hp} aircons →`;
        shopEl.href = AIRCON_SHOP_URL;
      }
    }
    areaEl.addEventListener("input", () => {
      $$("#afPresets .af-chip").forEach(c => c.classList.remove("active"));
      render();
    });
    $$("#afPresets .af-chip").forEach(chip => chip.addEventListener("click", () => {
      areaEl.value = chip.dataset.area;
      $$("#afPresets .af-chip").forEach(c => c.classList.toggle("active", c === chip));
      render();
    }));
    render();
  })();

  (function initArticleShare() {
    const buttons = $$("[data-copy-link]");
    if (!buttons.length) return;
    buttons.forEach(btn => {
      btn.addEventListener("click", () => {
        navigator.clipboard.writeText(btn.dataset.copyLink).then(() => {
          const original = btn.dataset.label || btn.getAttribute("aria-label");
          btn.setAttribute("aria-label", "Link copied!");
          btn.classList.add("copied");
          setTimeout(() => {
            btn.setAttribute("aria-label", original);
            btn.classList.remove("copied");
          }, 1600);
        });
      });
    });
  })();
})();
